import { Link } from "react-router-dom";
import { Truck } from "lucide-react";

export default function TopBar({ right }) {
  return (
    <header className="border-b border-zinc-200 bg-white sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-home-link"
          className="flex items-center gap-3 group"
        >
          <div className="h-9 w-9 bg-[#0033CC] flex items-center justify-center">
            <Truck className="h-5 w-5 text-white" strokeWidth={2.25} />
          </div>
          <div className="leading-tight">
            <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 font-semibold">
              Transport
            </div>
            <div className="font-bold text-[15px] tracking-tight text-zinc-900 -mt-0.5">
              Inquiry Control
            </div>
          </div>
        </Link>
        <div className="flex items-center gap-3">{right}</div>
      </div>
    </header>
  );
}
